import { useState, useCallback } from "react";
import { getTicket } from "../lib/ticket.js";

/**
 * Fournit une fonction `fetchTicket(idTicket)` pour charger un ticket à la demande et expose `{ ticket, loading, error, fetchTicket }`.
 *
 * @returns {{ ticket: object|null, loading: boolean, error: string|null, fetchTicket: Function }}
 */
export function useGetTicket() {
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTicket = useCallback(async (idTicket) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getTicket(idTicket);
      setTicket(data);
      return data;
    } catch (err) {
      setError(err.message || "Erreur lors de la récupération du ticket");
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    ticket,
    loading,
    error,
    fetchTicket,
  };
}
